var Handlebars = require("/home/jenkins/workspace/朵颐 - 发布POS前台/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    return "            <div class=\"singleDiscount\">"
    + container.escapeExpression(container.lambda((depth0 != null ? depth0.discountName : depth0), depth0))
    + "</div>\n";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.each.call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.tags : depth0),{"name":"each","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"4":function(container,depth0,helpers,partials,data) {
    return "                <div class=\"tag\">"
    + container.escapeExpression(container.lambda((depth0 != null ? depth0.name : depth0), depth0))
    + "</div>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {});

  return "<div id=\"billitem-edit\" data-id=\""
    + alias2(alias1((depth0 != null ? depth0.id : depth0), depth0))
    + "\">\n    <div class=\"item-name large\">"
    + alias2(alias1((depth0 != null ? depth0.menuItemName : depth0), depth0))
    + "</div>\n    <span class=\"order-time\">"
    + alias2(__default(require("/home/jenkins/workspace/朵颐 - 发布POS前台/src/hbHelpers/i18n.js")).call(alias3,"pos.table.item.time.order",{"name":"i18n","hash":{},"data":data}))
    + "："
    + alias2(__default(require("/home/jenkins/workspace/朵颐 - 发布POS前台/src/hbHelpers/formatDate.js")).call(alias3,(depth0 != null ? depth0.dateCreated : depth0),"time",{"name":"formatDate","hash":{},"data":data}))
    + "</span>\n    <div class=\"info grey\">\n        <span class=\"price\">"
    + alias2(alias1((depth0 != null ? depth0.price : depth0), depth0))
    + "</span>\n        <button class=\"btn edit-quantity minus-btn v-m\"></button>\n        <span class=\"quantity\">x<span class=\"order-quantity\">"
    + alias2(alias1((depth0 != null ? depth0.orderedQuantity : depth0), depth0))
    + "</span></span>\n        <button class=\"btn edit-quantity plus-btn v-m\"></button>\n    </div>\n    <div class=\"item-tag\">\n"
    + ((stack1 = helpers["if"].call(alias3,(depth0 != null ? depth0.discount : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers["if"].call(alias3,(depth0 != null ? depth0.tags : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "    </div>\n</div>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/templates/table/BillItemEdit.handlebars
// module id = 549
// module chunks = 0